module.exports = "<span class=\"header\"> {{'GeneralInformationAndLimitOfResponsibility' | translate}} </span>\n<br><br>\n<div>\n  <div class=\"description\">\n    <div></div>\n    <p [innerHTML]=\"'uitext.offer.options.disclaimer.desc' | translate\"></p>\n    <div></div>\n  </div>\n</div>\n<br>\n<button class=\"btn butn redBtn\" style=\" width: 25%; clear: both;\" [routerLink]=\"['/myOffers']\" (click)=\"onNextClick()\">\n  {{'Next' | translate}}\n</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/content/disclaimer/disclaimer.component.html
// module id = ./src/app/content/disclaimer/disclaimer.component.html
// module chunks = main